import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { cn } from '@ordering/utils/styling';
interface ProductMediaProps {
  imageUrl?: string;
  videoUrl?: string;
  alt: string;
  fill?: boolean;
}
export const ProductMedia: React.FC<ProductMediaProps> = t0 => {
  const $ = _c(8);
  const {
    imageUrl,
    videoUrl,
    alt,
    fill
  } = t0;
  if (videoUrl) {
    const t1 = fill && "absolute inset-0";
    let t2;
    if ($[0] !== t1) {
      t2 = cn(t1, "w-full h-full object-cover object-center bg-transparent pointer-events-none");
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== videoUrl) {
      t3 = <video key={videoUrl} src={videoUrl} autoPlay={true} loop={true} muted={true} playsInline={true} className={t2} />;
      $[2] = t2;
      $[3] = videoUrl;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (imageUrl) {
    let t1;
    if ($[5] !== alt || $[6] !== imageUrl) {
      t1 = <Image src={imageUrl} alt={alt} priority={true} className="w-full h-full object-cover object-center bg-transparent pointer-events-none" fill={true} sizes="100vw" />;
      $[5] = alt;
      $[6] = imageUrl;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  return null;
};